// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1xwRF","rootSmall":"AddTileButton_rootSmall__3ft2q"};